import React from 'react';

export default function ProfileAvatar({
  className = '',
  bgFrom = '#fff7ed',
  bgTo = '#fff1d6',
  fill = '#263238',
  initials = '',
  name = '',
}) {
  // Only show initials when explicitly provided via `initials` prop.
  const displayInitials = initials ? initials.slice(0,2).toUpperCase() : '';
  return (
    <svg
      viewBox="0 0 128 128"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={name ? `Avatar ${name}` : 'User avatar'}
    >
      <defs>
        <linearGradient id="bgGradM" x1="0" x2="1">
          <stop offset="0%" stopColor={bgFrom} />
          <stop offset="100%" stopColor={bgTo} />
        </linearGradient>
        <radialGradient id="glossM" cx="30%" cy="25%" r="60%">
          <stop offset="0%" stopColor="#ffffff" stopOpacity="0.55" />
          <stop offset="100%" stopColor="#ffffff" stopOpacity="0" />
        </radialGradient>
        <filter id="softShadowM" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="2" stdDeviation="6" floodColor="#000" floodOpacity="0.12" />
        </filter>
      </defs>

      <g filter="url(#softShadowM)">
        <circle cx="64" cy="64" r="60" fill="url(#bgGradM)" />
      </g>

      <ellipse cx="64" cy="40" rx="42" ry="30" fill="url(#glossM)" />

      <circle cx="64" cy="44" r="20" fill={fill} />

      <ellipse cx="64" cy="92" rx="36" ry="20" fill={fill} />

      <ellipse cx="64" cy="88" rx="24" ry="8" fill="#000" opacity="0.06" />

      <circle cx="64" cy="64" r="62" fill="none" stroke="#000" strokeOpacity="0.04" strokeWidth="2" />

      {displayInitials ? (
        <text x="64" y="50" textAnchor="middle" fontFamily="Inter, Arial, sans-serif" fontSize="28" fill="#ffffff" fontWeight="700">
          {displayInitials}
        </text>
      ) : null}
    </svg>
  );
}
